<script setup lang="ts">
import Dropdown from "../../components/Dropdown/Dropdown.vue";
import profil from "../../assets/images/userprofile.svg";
import { ref, onMounted, computed, getCurrentInstance } from "vue";

import { useUsersStore } from "../../store/users.store";
import AuthenticationHelper from "../../helper/OIDCManager";

import ButtonText from "@/components/Button/ButtonText.vue";
import Tag from "@/components/Tag/Tag.vue";

import { ENV_NAME, ENV_CENTERNAME } from "../../services/config";

import i18n from "../../i18n";
import buildVersion from "../../buildversion.json";

import { useAbility } from "@casl/vue";
import ModalEP from "../../components/Modal/ModalEP.vue";
import { Location } from "@element-plus/icons-vue";
import { usePerformanceStore } from "../../store/performance.store";
import { useDevOptionsStore } from "../../store/devOptions.store";
import PerformanceBadge from "../../components/Performance/PerformanceBadge.vue";
import { useFeatureLot } from "../../composables/FeatureLotComposable";
import router from "../../router";

const perfStore = usePerformanceStore();
const devOptionsStore = useDevOptionsStore();

const O2SAbility = useAbility()
const { canAccessRoute } = useFeatureLot();

/** Vérifie si un chemin de menu est accessible (rôle dédié, sinon CASL + feature lot) */
function isMenuItemAccessible(path: string): boolean {
  const route = router.getRoutes().find(r => r.path === path);
  // Outils de test (ex fabrique de commandes client) : masqués en production. Confort
  // d'affichage seulement — l'API renvoie déjà 404 hors develop/recette.
  if (route?.meta?.notInProduction && ENV_NAME?.toUpperCase() === "PRODUCTION") return false;
  // Routes réservées à un rôle (ex console admin) : visibilité gatée par le rôle OIDC,
  // pas par resource CASL (non seedée pour ces pages). Source de vérité = meta de la route.
  const requiredRole = route?.meta?.requiresRole as string | undefined;
  if (requiredRole) {
    return (usersStore.currentUser?.roles ?? []).includes(requiredRole);
  }
  const caslOk = O2SAbility.can("access", "global#page#" + path.substring(1));
  if (!caslOk) return false;
  if (route?.meta?.lot && !canAccessRoute(route.meta)) return false;
  return true;
}

const usersStore = useUsersStore();
const user = computed(() => usersStore.currentUser);
const initialsUser = computed(() => user?.value?.givenName?.charAt(0) + user?.value?.familyName?.charAt(0))

const languages = ref([
  { flag: "fr", language: "fr", title: i18n.global.t('common.french') },
  { flag: "gb", language: "en", title: "English" },
  { flag: "de", language: "de", title: "Deutsch" },
  { flag: "it", language: "it", title: "Italiano" },
]);

var changeLocale = (locale: any) => {
  i18n.global.locale.value = locale;
};

const flagWithLocal = computed(() =>
  languages.value.find((o) => o.language === i18n.global.locale.value)
);

const isExtended = ref(false);
const isProfilOpen = ref(false);
const isLogoutOpen = ref(false);

const position = ref("general");
const disable = ref(true);

const auth = new AuthenticationHelper();
//  --- À dynamiser ---
const client = ref({
  label: "",
  isOpen: false,
});

const options = ref([
  { label: i18n.global.t("profile.accountSettings"), icon: "setting_white.svg", action: "openProfil", isVisible: true },
  { label: "SyneliaConnect", icon: "synelia-connect.svg", path: "InfoUser", isVisible: O2SAbility.can("access", "global#page#InfoUser") },
  { label: i18n.global.t("common.exit"), icon: "logout.svg", action: "logout", isVisible: true },
]);

const userRoleApp = computed(() => {

  var userRoles = user.value.roles.filter(x => x.startsWith("GDPORC"))
  if (userRoles.length > 0) {
    return userRoles[0]
  } else {
    if (user.value.roles.length > 0) {
      return user.value.roles[0]
    } else {
      return "No role"
    }
  }

})

const menuItems = ref([]);

/**
 * Crétaion du menu
 *
 */
async function processMenu() {
  var arrSubMenu = [];
  var arrSubSubMenu = [];
  var option = {};
  var submenu = {};

  var nomUrl: string | undefined = "";

  for (const element of menuItemsStatic.value) {

    if (element.options) {
      for (const optionmenu of element.options) {
        option = {};

        nomUrl = optionmenu?.path;

        if (nomUrl != undefined) {
          var bOk = isMenuItemAccessible(nomUrl);

          if (bOk) {
            arrSubMenu.push(optionmenu);
          }

        } else {

          if (optionmenu.submenu) {
            for (const optionSubMenu of optionmenu.submenu) {
              submenu = {};

              nomUrl = optionSubMenu?.path;

              if (nomUrl != '') {
                var bOk = isMenuItemAccessible(nomUrl);

                if (bOk) {
                  arrSubSubMenu.push(optionSubMenu);
                }

              }

            }

            if (arrSubSubMenu.length > 0) {
              option = optionmenu;
              option.submenu = arrSubSubMenu;
              arrSubMenu.push(option);
              arrSubSubMenu = [];
            }

          }
        }
      }

      if (arrSubMenu.length > 0) {
        option = element;
        option.options = arrSubMenu;
        menuItems.value.push(option);
        arrSubMenu = [];
        option.isVisible = true
      }
    }
  }
}

onMounted(async () => {
  client.value.label = user.value.displayName; // Todo : à revoir.
});

//  --- À dynamiser ---
const menuItemsStatic = ref([
  {
    label: i18n.global.t("menuHeader.accueil"),
    icon: "home.svg",
    isOpen: false,
    isVisible: true,
    path: "#"
  },
  {
    label: i18n.global.t("menuHeader.gestionAnimaux"),
    icon: "pig.svg",
    isOpen: false,
    isVisible: false,
    options: [
      { label: i18n.global.t("menu.listAnimaux"), path: "/ListeAnimaux" },
      {
        label: i18n.global.t("menu.listOrders"),
        submenu: [
          { label: i18n.global.t("menu.listGestionOrders"), path: "/ListeCommande" },
          { label: i18n.global.t("menu.listOrdersStatus"), path: "/ListeHistoriqueStatutCommande" },
        ]
      },
      {
        label: i18n.global.t("menu.listInfoAnimaux"),
        submenu: [
          { label: i18n.global.t("menu.prepaReforms"), path: "/PreparationReformes" },
          { label: i18n.global.t("menu.reforms"), path: "/ListeReformes" },
          { label: i18n.global.t("menu.reserves"), path: "/ListeReserve" },
          { label: i18n.global.t("menu.listCaryotypes"), path: "/ListeCaryotype" }
        ],
      },
    ],
  },
  {
    label: i18n.global.t("menuHeader.gestionProduction"),
    icon: "factory-white.svg",
    isOpen: false,
    isVisible: false,
    options: [
      { label: i18n.global.t("menu.listProduction"), path: "/Production" },
      { label: i18n.global.t("menu.listePrelevements"), path: "/ListePrelevements" },
      { label: i18n.global.t("menu.listeHeterospermie"), path: "/ListeHeterospermie" },
      { label: i18n.global.t("menu.suiviFabrication"), path: "/SuiviFabrication" },
      {
        label: i18n.global.t("submenu.gestionDilueurs"),
        submenu: [
          { label: i18n.global.t("menu.listDilueurs"), path: "/ListeDilueurs" },
          { label: i18n.global.t("menu.listControlDilueur"), path: "/ControlDilueurs" },
        ],
      },
      { label: i18n.global.t("menu.listEvenementsPrelevement"), path: "/ListeEvenementsPrelevement" },
      { label: i18n.global.t("menu.mountingPlan"), path: "/PlanMonte" },
    ],
  },
  {
    label: i18n.global.t("menuHeader.gestionTiers"),
    icon: "customer.svg",
    isOpen: false,
    isVisible: false,
    options: [
      { label: i18n.global.t("menu.listAgents"), path: "/ListeCollaborateurs" },
      { label: i18n.global.t("menu.listCenters"), path: "/ListeCentres" },
      { label: i18n.global.t("menu.listElevages"), path: "/ListeElevage" },
      { label: i18n.global.t("menu.listProviders"), path: "/ListeProvider" },
      { label: i18n.global.t("menu.listOwners"), path: "/ListeOwner" },
      { label: i18n.global.t("menu.listCTG"), path: "/ListeCTG" },
      { label: i18n.global.t("menu.listCustomers"), path: "/ListeCustomers" },
      { label: i18n.global.t("menu.listCodesStock"), path: "/GestionCodesStock" },
    ],
  },
  {
    label: i18n.global.t("menuHeader.gestionOrders"),
    icon: "commandes.svg",
    isOpen: false,
    isVisible: false,
    options: [

    ],
  },
  {
    label: i18n.global.t('stock.shipment'),
    icon: "expedition.svg",
    isOpen: false,
    isVisible: false,
    options: [],
  },
  {
    label: "Stock",
    icon: "stock.svg",
    isOpen: false,
    isVisible: false,
    options: [
      { label: i18n.global.t("menu.listConsultationStock"), path: "/ListeConsultationStock" },
      { label: i18n.global.t("menu.consultationStock"), path: "/ConsultationStock" }
    ]
  },
  {
    label: "Commandes",
    icon: "commandes.svg",
    isOpen: false,
    isVisible: false,
    options: [
      { label: "Commandes client de test", path: "/admin/commandes-test" },
    ],
  },
  {
    label: i18n.global.t("menuHeader.gestionQualite"),
    icon: "quality.svg",
    isOpen: false,
    isVisible: false,
    options: [
      { label: i18n.global.t("menu.listQuality"), path: "/SuiviQualite" },
      { label: i18n.global.t("menu.listBlades"), path: "/ListeLames" }
    ],
  },
  {
    label: i18n.global.t("menuHeader.gestionSanitaire"),
    icon: "shield.svg",
    isOpen: false,
    isVisible: false,
    options: [
      { label: i18n.global.t("menu.sanitaryAnimals"), path: "/ListeAnimauxSanitaire" },
      { label: i18n.global.t("menu.listPharmacie"), path: "/ListePharmacie" },
      { label: i18n.global.t("menu.listEvenementsStation"), path: "/ListeEvenementsStation" },
    ],
  },
  {
    label: i18n.global.t('stock.depot'),
    icon: "depot.svg",
    isOpen: false,
    isVisible: false,
    options: [],
  },
  {
    label: "Echanges",
    icon: "echanges.svg",
    isOpen: false,
    isVisible: false,
    options: [],
  },
  {
    label: i18n.global.t("menuHeader.gestionDevices"),
    icon: "exchange.svg",
    isOpen: false,
    isVisible: false,
    options: [
      { label: i18n.global.t("menu.etalonnagePhotocolorimetre"), path: "/EtalonnagePhotocolorimetre" },
      { label: i18n.global.t("menu.listDevices"), path: "/ListeDevices" },
    ],
  },
  {
    label: i18n.global.t("menuHeader.utilities"),
    icon: "utilitaire.svg",
    isOpen: false,
    isVisible: false,
    options: [

      {
        label: i18n.global.t("menuHeader.gestionOptions"),
        submenu: [
          { label: i18n.global.t("menu.listOptions"), path: "/OptionUser" },
        ]
      },
      {
        label: i18n.global.t("menuHeader.gestionAdmin"),
        submenu: [
          { label: i18n.global.t("menu.listResources"), path: "/GestionRessources" },
          { label: i18n.global.t("menu.listParameters"), path: "/ListeParametres" },
          { label: i18n.global.t("menu.listTypePoudre"), path: "/ListeTypePoudres" },
          { label: i18n.global.t("menu.sanitaryCatalog"), path: "/GestionCatalogueSanitaire" },
        ]
      },
      { label: i18n.global.t("menu.listeBuildings"), path: "/ListeBatiments" },
    ],
  },
  {
    label: "BackOffice",
    icon: "admin.svg",
    isOpen: false,
    isVisible: false,
    options: [
      // Pas d'entrée « Catalogue sanitaire » ici : elle existe déjà sous Utilitaires >
      // Gestion admin. Deux entrées vers la même page, filtrées par le même droit, ne
      // donnent accès à rien de plus et se voient à la qualification.
      { label: i18n.global.t("menu.listSamplingEvents"), path: "/ListeEvenementsCollecte" },
      { label: i18n.global.t("menu.listMovementTypes"), path: "/ListeTypesMouvement" },
      { label: i18n.global.t('common.dataResync'), path: "/admin/resync" },
    ],
  },
  {
    label: "A ranger",
    icon: "warning.svg",
    isOpen: false,
    isVisible: false,
    options: [
      { label: i18n.global.t("menu.connexionBalance"), path: "/TestMesure" }
    ]
  },
  {
    label: "Utilitaires",
    icon: "utilitaire.svg",
    isOpen: false,
    isVisible: false,
    options: [],
  },
]);

const CenterAuthorise = () => {
  return user.value.codeSite_chefdecentre.concat(user.value.codesite);
};

// Étendre ou restreindre le menu de navigation
const extendsMenu = () => {
  isExtended.value = !isExtended.value;
  menuItems.value.forEach((item) => (item.isOpen = false));
  menuItems.value.forEach((item) =>
    item.options.forEach((submenu: any) => {
      if (submenu.isOpen !== undefined) {
        submenu.isOpen = false;
      }
    })
  );
  document
    .querySelectorAll(".submenu__container")
    .forEach((item: any) => (item.style.top = "0"));
};

const forceCloseMenu = (item) => {
  item.isOpen = false
}

// Calcul la position des sous-liens
const handlePosition = (e: any) => {
  if (!isExtended.value) {
    const dropdown = e.target.closest(".dropdown");
    const parentTop = e.target.closest(".dropdown-button")
      ? e.target.closest(".dropdown-button").getBoundingClientRect().y
      : "";
    const parentLeft = e.target.closest(".dropdown-button")
      ? e.target.closest(".dropdown-button").getBoundingClientRect().x
      : "";
    const dropdownContainer = dropdown
      ? dropdown.querySelector(".dropdown-button__container")
      : "";
    if (dropdownContainer) {
      dropdownContainer.style.top = `${parentTop}px`;
      dropdownContainer.style.left = `${parentLeft + 52}px`;
    }
  } else {
    e.target.closest(".dropdown").querySelector(".dropdown-button__container").style = "";
  }
};

// Calcul la position des sous-liens au scroll
const handleScrollPosition = () => {
  if (!isExtended.value) {
    const dropdown: any = document.querySelector(".dropdown-button--active");

    if (dropdown !== null) {
      dropdown
        .closest(".dropdown")
        .querySelector(".dropdown-button__container").style.top = `${dropdown.getBoundingClientRect().y - scrollY
        }px`;
    }
  } else {
    const dropdown2: any = document.querySelector(
      ".submenu__container--open"
    ) as HTMLElement;
    if (dropdown2 !== null) {
      dropdown2.style.top = `${dropdown2.closest(".dropdown-button__container--list").getBoundingClientRect().y -
        scrollY
        }px`;
    }
  }
};

// Gestion des dropdowns
const dropdownAction = (item: any) => {

  menuItems.value.forEach((element) => {
    if (item === element) {
      element.isOpen = !item.isOpen;
      element.options.forEach((option: any) =>
        option.submenu ? (option.isOpen = false) : ""
      );
    } else {
      if (!isExtended.value) {
        element.isOpen = false;
        isOpenProfile.value = false;
      }
    }
  });
};

const handleNav = (e: any, onglet: string) => {
  const container = e.target.closest(".el-dialog__body");
  const targ = e.target.classList.contains("nav__container-li")
    ? e.target
    : e.target.closest(".nav__container-li");

  // Ajouter la classe --active à l'élément cliqué
  container
    .querySelector(".nav__container-li--active")
    .classList.remove("nav__container-li--active");
  targ.classList.add("nav__container-li--active");

  // Affiche l'onglet de navigation souhaité
  position.value = onglet;
};

const isOpenProfile = ref(false);

function convertRoleName(userRole) {
  var userRoleTransform = userRole.replace('GDPORC_', '')
  userRoleTransform = userRoleTransform.replace(/([a-z])([A-Z])/g, '$1 $2');
  userRoleTransform = userRoleTransform.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
  userRoleTransform = userRoleTransform.toLowerCase()
  return userRoleTransform.charAt(0).toUpperCase() + userRoleTransform.slice(1);
}


onMounted(() => {
  var sidenav = document.getElementById("mySidenav");
  var openBtn = document.getElementById("openBtn");
  var closeBtn = document.getElementById("closeBtn");

  /* Set the width of the side navigation to 250px */
  function openNav() {
    sidenav?.classList.add("active");
  }

  /* Set the width of the side navigation to 0 */
  function closeNav() {
    sidenav?.classList.remove("active");
  }
  processMenu();
});
</script>

<template>
  <div class="menu-sidebar" :class="{ 'menu--extended': isExtended }">
    <input id="menu1Toggle" type="checkbox" />
    <label class="menu-toggle menu-1-toggle" for="menu1Toggle">
      <span class="menu-label"><span class="burger-icon">
          <span></span>
          <span></span>
          <span></span>
        </span></span>
      <span class="close-label">&times;</span>
    </label>

    <div class="sidebar menu-1">
      <div class="scrool-sidebar">
        <template v-for="item in menuItemsStatic.filter(x => x.isVisible == true)" :key="item.label">
          <div style="background-color: #7b6bff; padding: 3px">
            <img :src="`/images/${item.icon}`" class="menu__main--img" />
            <span style="margin-left: 10px">{{ item.label }}</span>
          </div>
          <div v-for="subitem in item.options" class="link">
            <a :href="'/#' + subitem.path">{{ subitem.label }}</a>
          </div>
        </template>
      </div>
    </div>
  </div>

  <div class="menu--container"
    :class="{ 'menu--develop': ENV_NAME == 'DEVELOP', 'menu--release': ENV_NAME == 'RELEASE', 'menu--prod-synelia': ENV_NAME == 'PRODUCTION' && ENV_CENTERNAME == 'SYNELIA' }">
    <div class="menu" :class="{ 'menu--extended': isExtended }">
      <div class="menu--top" @scroll="handleScrollPosition">
        <button class="menu__extandable--button" @click="extendsMenu">
          <img src="/src/assets/images/arrow.svg" alt="" />
        </button>
        <Dropdown class="dropdown-button__container--dark" :initValue="client"
          :selectionList="options.filter(x => x.isVisible == true)" :isAside="!isExtended"
          v-bind:class="{ 'dropdown--fixed': !isExtended }" @click="handlePosition"
          @openModalProfil="isProfilOpen = true" @logout="isLogoutOpen = true">
          <div class="menu__client menu__dropdown" v-if="isExtended">
            <div class="menu__dropdown--left">
              <img :src="user.picture" v-if="!user.picture.endsWith('userprofile.svg')" :alt="user.displayName"
                class="menu__client--img--round" />
              <div v-else :data-initials="initialsUser" class="medium"></div>
              <div class="menu__client--name menu__dropdown--name">
                {{ user.displayName }}
              </div>
            </div>
            <img class="menu__dropdown--chevron" src="/src/assets/images/chevron.svg" />
          </div>
          <img v-else v-if="!user.picture.endsWith('userprofile.svg')" :src="user.picture" :alt="user.displayName"
            class="menu__client--img--round" />
          <div v-else :data-initials="initialsUser" class="medium"></div>
        </Dropdown>

        <ModalEP v-model:visible="isProfilOpen" :title="$t('profile.accountSettings')">
          <template v-slot:body>
            <div style="display: grid; grid-template-columns: max-content 1fr; gap: 3rem">
              <nav class="nav">
                <ul class="nav__container">
                  <li class="nav__container-li nav__container-li--active" data-position="0"
                    @click="handleNav($event, 'general')">
                    <svg class="nav__container-li-img" width="22" height="22" viewBox="0 0 16 16" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.0592 5.20625C15.1592 5.47813 15.0748 5.78125 14.8592 5.975L13.8936 6.85313C13.6529 7.075 13.5373 7.4 13.5529 7.725C13.5561 7.81562 13.5592 7.90625 13.5592 8C13.5592 8.09375 13.5561 8.18437 13.5529 8.275C13.5373 8.60312 13.6498 8.92813 13.8936 9.14688L14.8592 10.025C15.0748 10.2188 15.1592 10.5219 15.0592 10.7937C14.9217 11.1656 14.7561 11.5219 14.5654 11.8656L14.4186 12.1187C14.2123 12.4625 13.9811 12.7875 13.7279 13.0938C13.5436 13.3188 13.2373 13.3937 12.9623 13.3062L11.7217 12.9125C11.4092 12.8125 11.0717 12.8781 10.7936 13.0562C10.6404 13.1531 10.4842 13.2469 10.3217 13.3281C10.0311 13.4781 9.80606 13.7406 9.73419 14.0594L9.45606 15.3313C9.39356 15.6156 9.17481 15.8406 8.88731 15.8875C8.45606 15.9594 8.01231 15.9969 7.55919 15.9969C7.10606 15.9969 6.66231 15.9594 6.23106 15.8875C5.94356 15.8406 5.72481 15.6156 5.66231 15.3313L5.38419 14.0594C5.31544 13.7406 5.08731 13.4781 4.79669 13.3281C4.63419 13.2437 4.47794 13.1531 4.32481 13.0562C4.04981 12.8781 3.70919 12.8125 3.39669 12.9125L2.15919 13.3094C1.88419 13.3969 1.57794 13.3188 1.39356 13.0969C1.14044 12.7906 0.909188 12.4656 0.702938 12.1219L0.556063 11.8687C0.365438 11.525 0.199813 11.1687 0.0623127 10.7969C-0.0376873 10.525 0.0466877 10.2219 0.262313 10.0281L1.22794 9.15C1.46856 8.92812 1.58419 8.60312 1.56856 8.27812C1.56544 8.1875 1.56231 8.09688 1.56231 8.00313C1.56231 7.90938 1.56544 7.81875 1.56856 7.72813C1.58419 7.4 1.47169 7.075 1.22794 6.85625L0.262313 5.975C0.0466877 5.78125 -0.0376873 5.47813 0.0623127 5.20625C0.199813 4.83438 0.365438 4.47813 0.556063 4.13438L0.702938 3.88125C0.909188 3.5375 1.14044 3.2125 1.39356 2.90625C1.57794 2.68125 1.88419 2.60625 2.15919 2.69375L3.39981 3.0875C3.71231 3.1875 4.04981 3.12187 4.32794 2.94375C4.48106 2.84687 4.63731 2.75312 4.79981 2.67188C5.09044 2.52187 5.31544 2.25937 5.38731 1.94062L5.66544 0.66875C5.72794 0.384375 5.94669 0.159375 6.23419 0.1125C6.66544 0.0375 7.10919 0 7.56231 0C8.01544 0 8.45919 0.0375 8.89044 0.109375C9.17794 0.15625 9.39669 0.38125 9.45919 0.665625L9.73731 1.9375C9.80606 2.25625 10.0311 2.51875 10.3248 2.66875C10.4873 2.75312 10.6436 2.84375 10.7967 2.94062C11.0717 3.11875 11.4123 3.18125 11.7248 3.08437L12.9654 2.69062C13.2404 2.60312 13.5467 2.68125 13.7311 2.90313C13.9842 3.20938 14.2154 3.53437 14.4217 3.87812L14.5686 4.13125C14.7592 4.475 14.9248 4.83125 15.0623 5.20312L15.0592 5.20625ZM7.56231 10.5C8.22536 10.5 8.86124 10.2366 9.33008 9.76777C9.79892 9.29893 10.0623 8.66304 10.0623 8C10.0623 7.33696 9.79892 6.70107 9.33008 6.23223C8.86124 5.76339 8.22536 5.5 7.56231 5.5C6.89927 5.5 6.26339 5.76339 5.79455 6.23223C5.32571 6.70107 5.06231 7.33696 5.06231 8C5.06231 8.66304 5.32571 9.29893 5.79455 9.76777C6.26339 10.2366 6.89927 10.5 7.56231 10.5Z"
                        fill="#707070" />
                    </svg>
                    {{ $t('profile.general') }}
                  </li>
                  <li class="nav__container-li" data-position="300" @click="handleNav($event, 'autorisations')">
                    <svg class="nav__container-li-img" width="22" height="22" viewBox="0 0 24 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1655_152123)">
                        <path
                          d="M12 0L12.5437 0.210938L22.2703 3.98438L23.1703 4.33125L23.2266 5.29219C23.3625 7.63594 22.9969 11.2125 21.4781 14.7094C19.9453 18.2344 17.2078 21.7406 12.6 23.7375L12 24L11.4047 23.7422C6.79218 21.7453 4.05468 18.2437 2.52655 14.7141C1.00312 11.2172 0.637492 7.63594 0.778117 5.29688L0.834367 4.33594L1.72968 3.98438L11.4562 0.210938L12 0ZM17.2969 9.79688L18.0937 9L16.5 7.41094L15.7031 8.20781L10.5 13.4109L8.29687 11.2078L7.49999 10.4109L5.91093 12L6.7078 12.7969L9.7078 15.7969L10.5047 16.5938L11.3016 15.7969L17.2969 9.79688Z"
                          fill="#707070" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1655_152123">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    {{ $t('profile.permissions') }}
                  </li>
                </ul>
              </nav>

              <div v-if="position == 'general'">
                <div class="modal__container-top" style="margin-bottom: 2rem">
                  <div class="modal__container-top-profil">
                    <img class="modal__container-top-img" v-if="!user.picture.endsWith('userprofile.svg')"
                      :src="user.picture" :alt="user.displayName" style="height: 48px; width: 48px" />
                    <div :data-initials="initialsUser"></div>
                  </div>
                  <el-dropdown>
                    <el-button circle>
                      <flag :iso="flagWithLocal?.flag" v-bind:squared="false" />
                    </el-button>
                    <el-icon style="margin-right: 8px; margin-top: 1px" size="20px">
                      <location />
                    </el-icon>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item index="2-1" v-for="entry in languages" :key="entry.title"
                          @click="changeLocale(entry.language)">
                          <el-button class="btn-violet" plain style="width: 100%"
                            :class="[i18n.global.locale.value == entry.language ? 'active' : '']">
                            <el-space wrap>
                              <flag :iso="entry.flag" v-bind:squared="false" />
                              {{ entry.title }}
                            </el-space>
                          </el-button>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>

                <form class="modal__container-content">
                  <div class="modal__container-content-group">
                    <div class="modal__container-content-group-list">
                      <div class="input input--disabled">
                        <label class="input__label"> {{ $t('profile.firstName') }} </label>
                        <input class="input__field input__field--small" type="text" :disabled="disable"
                          :value="user?.givenName" />
                      </div>
                      <div class="input input--disabled">
                        <label class="input__label"> {{ $t('profile.lastName') }} </label>
                        <input class="input__field input__field--small" type="text" :disabled="disable"
                          :value="user.familyName" />
                      </div>
                      <div class="input input--disabled">
                        <label class="input__label"> {{ $t('profile.email') }} </label>
                        <input class="input__field input__field--small" type="text" :disabled="disable"
                          :value="user.email" />
                      </div>
                      <div class="input input--disabled"></div>
                    </div>
                  </div>
                </form>

                <div class="modal__container-content"
                  style="margin-top: 1.5rem; border-top: 1px solid #eee; padding-top: 1.5rem;">
                  <div class="modal__container-content-group">
                    <div class="input__label" style="margin-bottom: 0.5rem;">{{ $t('profile.devTools.title')
                    }}</div>
                    <div style="display: flex; align-items: center; gap: 0.75rem;">
                      <el-switch v-model="perfStore.isEnabled" active-color="#409eff" />
                      <span style="font-size: 13px; color: #606266;">
                        {{ $t('profile.devTools.performanceTracking') }}
                        <span v-if="perfStore.isEnabled" style="color: #409eff; font-weight: 600;"> {{
                          $t('profile.devTools.active')
                        }}</span>
                      </span>
                      <PerformanceBadge page="Initialisation" />
                    </div>
                    <div style="display: flex; align-items: center; gap: 0.75rem; margin-top: 0.5rem;">
                      <el-switch v-model="devOptionsStore.showCompteurCellDetail" active-color="#409eff" />
                      <span style="font-size: 13px; color: #606266;">
                        {{ $t('profile.devTools.compteurCellDetail') }}
                        <span v-if="devOptionsStore.showCompteurCellDetail" style="color: #409eff; font-weight: 600;">
                          {{
                            $t('profile.devTools.active') }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="position == 'autorisations'">

                <div class="modal__container-content">



                  <form class="modal__container-content">
                    <div class="modal__container-content-group">
                      <div class="modal__container-content-group-list">
                        <div class="input input--disabled">
                          <label class="input__label"> <i>{{ $t('profile.roles') }} : </i> </label>
                          <el-space wrap>

                            <Tag round v-for="item in user.roles.filter(x => x.startsWith('GDPORC_'))"
                              :tagTitle="convertRoleName(item)" :bgColor="'#34495e'"></Tag>
                          </el-space>
                        </div>
                        <div class="input input--disabled">
                          <label class="input__label"> <i>{{ $t('profile.authorizedCenters') }} : </i> </label>

                          <el-space wrap>
                            <template v-for="item in user.centersUser">
                              <Tag round :tagTitle="item.label"
                                :bgColor="item.center.typology.code3 == 'P' ? '#2B48A2' : '#00719c'" />
                            </template>
                          </el-space>
                        </div>
                      </div>
                    </div>
                  </form>




                </div>
              </div>
            </div>


          </template>
        </ModalEP>
        <ModalEP v-model:visible="isLogoutOpen" :title="$t('common.exit')" :size="'small'">
          <template v-slot:body>
            <div class="modal__container-content">
              <div class="modal__container-content-group">
                <div class="modal__container-content-group-list">
                  <p>{{ $t('exit') }}</p>
                </div>
              </div>
            </div>
          </template>
          <template #footer>
            <div class="validation">
              <ButtonText :is-cancel="true" color="cancel" width="50%" :title="$t('stayApp')"
                @click="isLogoutOpen = false" />
              <ButtonText :is-default="true" :title="$t('common.leave')" color="white" width="50%"
                @click="auth.logout()" />
            </div>
          </template>
        </ModalEP>

        <Dropdown @forceCloseMenuItem="forceCloseMenu(item)"
          v-for="item in menuItemsStatic.filter(x => x.isVisible == true)" :key="item.label" :initValue="item"
          :selectionList="item.options ?? []" :selectChoice="() => { }" :isAbsolute="!isExtended" :isAside="!isExtended"
          class="dropdown-button__container--dark" v-bind:class="{ 'dropdown--fixed': !isExtended }"
          @click="handlePosition" :isOpen="item.isOpen" :dropdownActions="() => dropdownAction(item)" isStatic>
          <div class="menu__main menu__dropdown" v-if="isExtended">
            <div class="menu__dropdown--left">
              <img :src="`images/${item.icon}`" class="menu__main--img" />
              <div class="menu__main--name menu__dropdown--name">
                {{ item.label }}
              </div>
            </div>
            <img class="menu__dropdown--chevron" src="/src/assets/images/chevron.svg" />
          </div>
          <img v-else :src="`images/${item.icon}`" class="menu__client--img" />
        </Dropdown>
      </div>
      <div class="menu--logo">
        <img :src="`images/logo-genepro-${isExtended ? 'expand' : 'collapse'}.svg`" alt="" />
        <el-tooltip
          :content="`${new Date(buildVersion.buildDeployedDatetime * 1000).toLocaleString()} - ${ENV_CENTERNAME}`"
          effect="customized" placement="right">
          <figcaption style="font-size:0.6em;color:white">{{ buildVersion.buildMajor }}.{{ buildVersion.buildMinor }}.{{
            buildVersion.buildRevision }}</figcaption>
        </el-tooltip>

        <hr>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use "../../assets/css/utils/_variables.scss" as *;

.menu--container {
  background-color: #333646;
}

.menu--develop {
  background-color: #16a085;
}

.menu--release {
  background-color: #e67e22;
}

.menu--prod-synelia {
  background-color: #d4ab63;
}

.menu--logo {
  cursor: help;
}

[data-initials]:before {
  background: #00719c;
  color: white;
  opacity: 1;
  content: attr(data-initials);
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  display: inline-block;
  font-weight: 200;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 0.5em;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

[data-initials].small:before {
  width: 25px;
  height: 25px;
  line-height: 25px;
}

[data-initials].medium:before {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.sidebar {
  background-color: #2B48A2;
  z-index: 4;
  width: 200px;
  position: fixed;
  top: 0;
  bottom: 0;
  padding-top: 66px;
  color: white;
  transition: 250ms;
}

.sidebar .link {
  padding: 8px 25px;
  cursor: pointer;
  transition: 250ms;
  font-weight: 300;
}

.sidebar .link a {
  text-decoration: none;
  color: white;
}

.sidebar .link a:hover {
  color: #2B48A2;
}

.sidebar .link:hover {
  background-color: white;
}

.sidebar.menu-1 {
  left: -200px;
  overflow: scroll;
  @include scrollbar-sidebar;
}

.sidebar.menu-2 {
  right: -200px;
}

.menu-toggle {
  z-index: 100;
  position: fixed;
  top: 25px;
  border: 1px solid #ebebeb;
  color: #ebebeb;
  border-radius: 4px;
  cursor: pointer;
  transition: 250ms;
}

.menu-toggle.menu-2-toggle {
  right: 25px;
}

.menu-toggle .menu-label {
  display: block;
}

.menu-toggle .close-label {
  display: none;
}

#menu1Toggle {
  display: none;
}

#menu1Toggle:checked~.sidebar.menu-1 {
  left: 0;
  box-shadow: 0 0 15px #000;
}

#menu1Toggle:checked~.menu-toggle.menu-1-toggle {
  border-color: #ebebeb;
  color: #ebebeb;
  left: 115px;
}

#menu1Toggle:checked~.menu-toggle.menu-1-toggle .menu-label {
  display: none;
}

#menu1Toggle:checked~.menu-toggle.menu-1-toggle .close-label {
  display: block;
  padding: 5px 10px;
  top: 0px;
}

.burger-icon span {
  display: block;
  width: 25px;
  height: 4px;
  background-color: #2B48A2;
  margin: 4px 0;
}

.burger-icon {
  width: 40px;
  height: 40px;
  position: absolute;
  top: -5px;
  left: 15px;
  cursor: pointer;
  z-index: 3;
}

.menu-sidebar {
  display: none;

  @media screen and (max-width: 600px) {
    display: block;
  }
}

.menu {
  height: 100%;
  width: fit-content;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;

  @media screen and (max-width: 600px) {
    display: none;
  }

  .dropdown {
    height: 50px;

    &-button {
      display: flex;
      justify-content: center;
      border: none;
      box-shadow: none;
      width: 56px;
      height: 56px;
    }
  }

  .dropdown-button__container--dark {
    .dropdown-button__container {
      color: $white;
      background-color: $black-grey;
      border: none;
    }
  }

  &__extandable--button {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 100%;
    top: 1rem;
    background-color: $blue-officiel-gd;
    border: none;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    cursor: pointer;
    z-index: 3;

    img {
      transform: rotate(180deg);
    }
  }

  &__dropdown {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    &--left {
      display: flex;
      align-items: center;
    }

    &--chevron {
      filter: brightness(0) invert(1);
    }

    &--name {
      margin-left: 16px;
      font-size: 16px;
      color: $white;
    }
  }

  &__client {
    &--img--round {
      border-radius: 50%;
      width: 24px;
      height: 100%;
    }

    &--name {
      font-weight: 700;
    }
  }

  &__home--link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin-left: 16px;
    }

    &:hover {
      background-color: $blue;
    }
  }

  &--logo {
    padding-top: 16px;
  }
}

.menu--extended {
  min-width: 276px;

  .menu--top {
    width: 100%;
    overflow-y: auto;
  }

  .dropdown {
    margin: 0 0 8px 0;
    width: 100%;

    &-button {
      width: inherit;
      height: auto;
    }
  }

  .dropdown-button__container {
    position: relative;
    z-index: 10;
    background-color: #4c516b !important;
  }

  .menu__home--link {
    justify-content: left;
    padding: 17px 16px;
    box-sizing: border-box;
    width: 100%;
    margin: 8px 0;
    height: initial;
    color: $white;
    text-decoration: none;
    font-size: 16px;
    line-height: 22px;
  }

  .menu__extandable--button {
    img {
      transform: rotate(0);
    }
  }
}

.nav {
  height: 100%;
  border-radius: 4px;
  overflow: hidden;

  &__container {
    height: 100%;
    list-style: none;
    background-color: $white-blue;
    margin: 0;
    padding: 0;

    &-li {
      padding: 1rem;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 1rem;
      cursor: pointer;

      &--active {
        background-color: $light-blue;
        color: $blue;

        svg path {
          fill: $blue;
        }
      }

      &-img {
        width: 22px;
      }
    }
  }
}

.input--disabled {
  .input__field {
    cursor: default;
    background-color: $light-grey;
    border: 1px solid $grey;

    &:focus-visible {
      outline: none;
    }
  }
}

.el-popper.is-customized {
  /* Set padding to ensure the height is 32px */
  padding: 6px 12px;
  font-size: 0.9em;
  background: linear-gradient(90deg, #2B48A2, #b9b0ff);
}

.el-popper.is-customized .el-popper__arrow::before {
  background: linear-gradient(45deg, #2B48A2, #2B48A2);
  right: 0;
}

.validation {
  display: flex;
  width: 100%;
  gap: 50px;
}
</style>
